import * as LoginGoogleButton from '../login/LoginGoogle.button';
import * as ClassroomActiveCard from '../user/home/active/ClassroomActive.card';
import * as BookCard from '../classroom/BookCard';
import { isElectronApp } from '../../services/crossPlatform/crossPlatformService';
import * as DownloadBookManager from '../classroom/DownloadBookManager';

const ELECTRON_VERSION = 'electron';
const WEB_VERSION = 'web';

/**
 * Initialize cross-platform components
 */
export let initComponentSpecializations = () => {
  if (isElectronApp()) {
    LoginGoogleButton.configure(ELECTRON_VERSION);
    ClassroomActiveCard.configure(ELECTRON_VERSION);
    BookCard.configure(ELECTRON_VERSION);
    DownloadBookManager.configure(ELECTRON_VERSION);
  } else {
    LoginGoogleButton.configure(WEB_VERSION);
    ClassroomActiveCard.configure(WEB_VERSION);
    BookCard.configure(WEB_VERSION);
    DownloadBookManager.configure(WEB_VERSION);
  }
};
